<template>
  <div class="app-container">
    <PageTitle title="身份证列表" ref="pageTitle" />
    <div class="filter-container">
      <el-upload
        class="filter-item"
        :action="uploadAction"
        :headers="uploadHeaders"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-success="onUploadSuccess"
        :on-error="onUploadError"
        accept=".csv, .xls, .xlsx"
      >
        <el-button type="primary">Excel导入身份证</el-button>
      </el-upload>
      <el-button class="filter-item" type="primary" @click="delAllIdCard" style="margin-right: auto"
        >一键移除身份证</el-button
      >
    </div>
    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:add_time>
        <el-table-column label="添加时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="success" :underline="false">{{ scope.row.add_time }}</el-link>
          </template>
        </el-table-column>
      </template>
      <template v-slot:action>
        <el-table-column label="操作" minWidth="220">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              @click="handleDel(scope.row.id)"
            />
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
  </div>
</template>

<script>
import { getList, exportCards, del, delAll } from '@/api/idCards'
import PageTitle from '@/components/PageTitle'
import { getToken } from '@/utils/auth'

export default {
  name: 'IdCards',
  components: {
    PageTitle
    // Edit
  },
  // mixins: [ProjectMixin],
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        city: ''
      },

      columns: [
        {
          type: 'index',
          align: 'center',
          label: '序号',
          width: '50'
        },
        {
          label: 'ID',
          width: '120',
          align: 'center',
          prop: 'id'
        },
        {
          label: '身份证姓名',
          width: '100',
          prop: 'name',
          align: 'center'
        },
        {
          label: '导游身份证',
          width: '160',
          prop: 'id_card',
          align: 'center'
        },
        {
          label: '添加时间',
          slot: 'add_time'
        },
        {
          label: '操作',
          slot: 'action'
        }
      ],
      uploadAction: '',
      uploadHeaders: {
        token: getToken()
      }
    }
  },
  created() {
    this.fetchData()
    this.uploadAction = exportCards()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      getList(this.listQuery).then((res) => {
        this.list = res.data.results.map((item) => {
          return { ...item }
        })

        this.count = res.data.count
        this.listLoading = false
      })
    },
    delAllIdCard() {
      this.$confirm('确认一键移除所有身份证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delAll().then(() => {
          this.$notify({
            title: '操作成功',
            type: 'success'
          })
          this.fetchData()
        })
      })
    },
    // 批量导入判断
    beforeUpload(file) {
      const _this = this
      let fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isFile = fileType === 'xls' || fileType === 'xlsx' || fileType === 'cvs'
      if (!isFile) {
        _this.$message.error('上传文件只能是 xls、xlsx、cvs格式!')
      }
      return isFile
    },
    // 批量导入上传成功
    onUploadSuccess(res) {
      if (res.code === 20000) {
        this.fetchData()
        this.$notify({
          title: '导入成功',
          message: res.msg,
          type: 'success'
        })
      } else {
        this.onUploadError(res)
      }
    },
    // 批量导入上传失败
    onUploadError(err) {
      this.$notify({
        title: '导入失败',
        message: err.msg,
        type: 'error'
      })
    },

    // 删除
    handleDel(uuid) {
      this.$confirm('确认删除该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          del(uuid).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
